import React, { useEffect, useState, useRef, useContext } from 'react';
import './castingCall.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { useParams, useNavigate } from 'react-router-dom';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import Alert from "../common/Alert";
import { Helmet } from "react-helmet-async";
import {
  apply,
  getAppliedRoleListForUser,
  getCastingCallByID,
} from '../../api/axios';
import { Spinner } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';


const CastingCallView = () => {
  const { id } = useParams();
  const { isAuthenticated, role, userId, token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [castingCall, setCastingCall] = useState({});
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);
  const rolesRef = useRef([]);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [applyButtonVisible, setApplyButtonVidible] = useState(true);
  const [appliedRoleList, setAppliedRoleList] = useState([]);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [clickedRoleIds, setClickedRoleIds] = useState([]);
  const [alertMessage, setAlertMessage] = useState();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('');
  const isCrewCasting = castingCall?.category?.toLowerCase() === 'crew';
  const GetCastingCallByID = async (id) => {
    nprogress.start();
    setLoading(true); // Ensure loading state is set to true before starting the request.

    try {
      const res = await getCastingCallByID(id);

      if (res.success) {
        const casting = res.casting;

        // Ensure casting.roles is an array before attempting to map
        if (Array.isArray(casting.roles) && casting.roles.length > 0) {
          casting.roles = casting?.roles && casting.roles?.map((role) => {
            if (role.ethnicity) {
              try {
                // Safely parse ethnicity
                role.ethnicity = JSON.parse(role.ethnicity);
                // console.log('Casting Call by ID response role.ethnicity:', role.ethnicity);
              } catch (error) {
                console.error('Error parsing ethnicity for role:', role);
              }
            }
            return role;
          });
        }

        // console.log('Casting Call by ID response:', casting);
        setCastingCall(casting);
      }
    } catch (error) {
      console.error('Error fetching casting call:', error);
    } finally {
      nprogress.done();
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      GetCastingCallByID(id);
    }
  }, [id]);

  const GetAppliedRoleListForUser = async (castingId, userId) => {
    try {
      const res = await getAppliedRoleListForUser(castingId, userId);
      if (res.success) {
        const roleIds = res?.application && res?.application.map(
          (application) => application.roleId
        );
        setAppliedRoleList(roleIds);
      }
    } catch (error) {
      // console.log('error fetching applied role list', error);
    }
  };
  useEffect(() => {
    const fetchPaymentHistory = async () => {
      // console.log('Fetching function is working');

      try {
        const response = await axios.get(
          // `http://localhost:5000/payments/payby-details/${userId}`,
          `https://webback.opencurtainscasting.com/payments/payby-details/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // console.log('API Response:', response.data);
        if (response.data.success && Array.isArray(response.data.result)) {
          setSubscriptionData(response.data.result);

          // Store hasSubscription in state
          setHasSubscription(response.data.result.length > 0);
        } else {
          console.error('Invalid API response format:', response.data);
          setError('Invalid data format.');
        }
      } catch (err) {
        console.error(
          'API Error:',
          err.response ? err.response.data : err.message
        );
        setError('Failed to load payment history.');
      } finally {
        setLoading(false);
      }
    };

    if (userId && token) {
      fetchPaymentHistory();
    }
  }, [userId, token]);

  useEffect(() => {
    if (id && userId && (role === 'actor' || role === 'crew')) {
      GetAppliedRoleListForUser(id, userId);
    }
  }, [id, userId, role]);

  useEffect(() => {
    rolesRef.current = new Array(castingCall.roles?.length).fill(null);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (isAuthenticated && (role === 'director' || role === 'producer')) {
      setApplyButtonVidible(false);
    }
  }, [isAuthenticated, role]);

  const scrollToRef = (ref) => {
    if (ref) {
      const navbarHeight = 105;
      const topPosition =
        ref.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: topPosition, behavior: 'smooth' });
    }
  };

  const handleClickEditCC = (id) => {
    navigate(`/castingcalls/edit/${id}`);
  };

  const handleApply = async (roleId) => {


    if (!isAuthenticated) {
      handleSubscribe();
      return;
    }

    if (!hasSubscription) {
      handleSubscribe();
      return;
    }

    const body = {
      roleId: roleId,
      castingId: id,
      castingRole: role
    };

    console.log('Applying with body:', body);

    try {
      const res = await apply(body);
      console.log('Application response:', res);

      if (res.success) {
        setAlertSeverity('success');
        setAlertMessage('Application successful!');
        GetAppliedRoleListForUser(id, userId);
        // Update applied role list dynamically
        setAppliedRoleList((prev) => [...prev, roleId]);

        // Mark this role as clicked (so button changes to "Selected")
        setClickedRoleIds((prev) => [...prev, roleId]);
      }
    } catch (error) {
      setAlertSeverity("info");
      setAlertMessage(error.response?.data?.message);
    } finally {
      setOpenSnackbar(true);
    }
  };

  const handleSubscribe = () => {
    // console.log('Button Clicked!');
    navigate('/subscriptions');
  };

  if (loading) {
    return (
      <div className='spinner-page'>
        <Spinner className='spinner' />
      </div>
    );
  }

  console.log('Rendering CastingCallView - castingCall:', castingCall);
  return (
    <>
      <Helmet>
        <title>{castingCall?.title || "Casting Call"}</title>

        <meta
          name="description"
          content={castingCall?.shortDesc || "View casting call details"}
        />

        <meta property="og:title" content={castingCall?.title || "Casting Call"} />
        <meta
          property="og:description"
          content={castingCall?.shortDesc || "View casting call details"}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content={
            castingCall?.thumbnail ||
            "https://i.ibb.co.com/0pDWW0tc/Casting-Call.jpg"
          }
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={castingCall?.title || "Casting Call"}
        />
        <meta
          name="twitter:description"
          content={castingCall?.shortDesc || "View casting call details"}
        />
        <meta
          name="twitter:image"
          content={
            castingCall?.thumbnail ||
            "https://i.ibb.co.com/0pDWW0tc/Casting-Call.jpg"
          }
        />
      </Helmet>
      <div className='castingCall-view-full-wrapper'>
        <div className='castingCall-view-container'>
          <div className='castingCall-view-grid'>
            <div className='castingCall-view-details'>
              <span className='all-role-count' ref={titleRef}>
                {castingCall.title}
              </span>
              <div className='castingCall-view-location'>
                <div className='castingCall-view-location-left'>
                  <span>{castingCall.zipCode}</span>
                  <span>ID: {castingCall.id}</span>
                  <span>
                    <FontAwesomeIcon icon={faCalendarAlt} />{' '}
                    {castingCall.expirationDate}
                  </span>
                </div>

                {applyButtonVisible && (isCrewCasting || castingCall.roles?.length > 0) && (
                  <button
                    className='castingCall-view-apply-button'
                    onClick={() => {
                      if (!isAuthenticated || !hasSubscription) {
                        navigate('/subscriptions');
                        return;
                      }

                      if (isCrewCasting || castingCall.roles?.length === 1) {
                        // If only one role, apply directly
                        const roleToApply = castingCall.roles[0];
                        if (roleToApply && !appliedRoleList.includes(roleToApply.id)) {
                          handleApply(roleToApply.id);
                        }
                      } else {
                        // If multiple roles, scroll to the roles section
                        scrollToRef(buttonRef.current);
                      }
                    }}
                    disabled={
                      isCrewCasting
                        ? appliedRoleList.includes(castingCall.roles?.[0]?.id)
                        : castingCall.roles?.length > 0 &&
                          appliedRoleList.length === castingCall.roles.length
                    }
                  >
                    {isCrewCasting
                      ? appliedRoleList.includes(castingCall.roles?.[0]?.id)
                        ? 'Applied'
                        : 'Apply'
                      : appliedRoleList.length === castingCall.roles?.length
                        ? 'Applied'
                        : (castingCall.roles?.length > 1 ? 'Choose a Role' : 'Apply')}
                  </button>
                )}


                {(role === 'director' || role === 'producer') && (
                  <button
                    className='castingCall-view-apply-button'
                    onClick={() => handleClickEditCC(id)}
                  >
                    Edit
                  </button>
                )}
              </div>
              <div className='seperate-line'></div>
              <div className='castingCall-view-location'>
                <div className='castcall-categories'>
                  <span className='castcall-category'>
                    {castingCall.category}
                  </span>
                  {castingCall.amount && (
                    <span className='title-right'>
                      ${castingCall.amount}/{castingCall.period}
                    </span>
                  )}
                </div>
                <span className="value">
  {castingCall?.area === 'world'
    ? 'Worldwide'
    : castingCall?.area === 'nation'
    ? 'Nationwide'
    : castingCall?.area === 'local'
    ? 'Local'
    : ''}
</span>
              </div>

              <div className='seperate-line'></div>
              <span className='castingCall-view-subTitle' ref={descriptionRef}>
                Description :
              </span>
              <div className='castingCall-view-des'>{castingCall.shortDesc}</div>
              {castingCall.companyName && (
                <span className='castingCall-view-des'>
                  Company Title : {castingCall.companyName}
                </span>
              )}
              {castingCall.contactNo && (
                <span className='castingCall-view-des'>
                  Company number : {castingCall.contactNo}
                </span>
              )}
              {castingCall.websiteURL && (
                <span className='castingCall-view-des'>
                  Company url :{' '}
                  <a
                    href={castingCall.websiteURL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='link'
                    style={{ textDecoration: 'none', color: '#e54447' }}
                  >
                    {castingCall.websiteURL}
                  </a>
                </span>
              )}
              <div className='seperate-line'></div>
              {isCrewCasting && (
                <span className='castingCall-view-subTitle'>Crew position</span>
              )}
              {!isCrewCasting && <span className='all-role-count' ref={buttonRef}>
                {castingCall.roles?.length}{' '}
                {castingCall.roles?.length === 1 ? 'role' : 'roles'}
              </span>}
              {!isCrewCasting && castingCall.roles?.map((item, index) => {
                const isApplied = appliedRoleList.includes(item.id);
                return (
                  <div
                    className='castingCall-view-role-container'
                    key={item.id}
                    ref={(el) => (rolesRef.current[index] = el)}
                  >
                    <span className='castingCall-view-subTitle'>
                      {item.title}
                    </span>
                    <div className='castingCall-view-des'>
                      <span>{item.gender} </span>
                      <span>
                        {item.ageMin}-{item.ageMax} y.o
                      </span>
                    </div>
                    {/* <span className='castingCall-view-des'>
                    {item?.ethinicity&& item?.ethinicity?.map((item, index) => (
                      <span key={index}>{item}, </span>
                    ))}
                  </span> */}
                    <span className='castingCall-view-des'>
                      {item.description}
                    </span>
                    {/* {applyButtonVisible && 
                    (isApplied ? (
                      <button
                        className="castingCall-role-apply-button"
                        disabled
                      >
                        Selected
                      </button>
                    ) : (
                      <button
                        className="castingCall-role-apply-button"
                        onClick={() => {
                          handleApply(item.id);
                          // handleSubscribe();
                        }}
                        // onClick={handleSubscribe}
                      >
                        Select
                      </button>
                    ))} */}
                    {applyButtonVisible &&
                      (isApplied || clickedRoleIds.includes(item.id) ? (
                        hasSubscription || clickedRoleIds.includes(item.id) ? (
                          <button
                            className='castingCall-role-apply-button'
                            disabled
                          >
                            Selected
                          </button>
                        ) : (
                          <button
                            className='castingCall-role-apply-button'
                            onClick={() => handleApply(item.id)}
                          >
                            Select
                          </button>
                        )
                      ) : (
                        <button
                          className='castingCall-role-apply-button'
                          onClick={() => handleApply(item.id)}
                        >
                          Select
                        </button>
                      ))}
                  </div>
                );
              })}
            </div>
            <div className='castingCall-view-ref-container'>
              <span className='castingCall-view-ref-title'>Overview</span>
              <div className='castingCall-ref-list'>
                <span
                  className='castingCall-ref'
                  onClick={() => scrollToRef(titleRef.current)}
                >
                  Intro
                </span>
                <span
                  className='castingCall-ref'
                  onClick={() => scrollToRef(descriptionRef.current)}
                >
                  Description
                </span>
              </div>
              {!isCrewCasting && <>
                <span className='castingCall-view-ref-title'>
                  Roles ({castingCall.roles?.length})
                </span>
                <div className='castingCall-ref-list'>
                  {castingCall.roles && castingCall.roles?.map((item, index) => (
                    <span
                      className='castingCall-ref'
                      key={item.id}
                      onClick={() => scrollToRef(rolesRef.current[index])}
                    >
                      {item.title}
                    </span>
                  ))}
                </div>
              </>}
            </div>
          </div>
        </div>
        <Alert
          openSnackbar={openSnackbar}
          alertSeverity={alertSeverity}
          setOpenSnackbar={setOpenSnackbar}
          alertMessage={alertMessage}
        />
      </div>
    </>

  );
};

export default CastingCallView;
